import z from "zod";

// TODO: Add actual error types for CompanyCam external service
const companyCamErrorTypeValues = ["PLACEHOLDER_ERROR"] as const;

const companyCamErrorTypeSchema = z.enum(companyCamErrorTypeValues);
const CompanyCamErrorType = companyCamErrorTypeSchema.enum;
type CompanyCamErrorType = z.infer<typeof companyCamErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type CompanyCamErrors = {
  errorType: typeof CompanyCamErrorType.PLACEHOLDER_ERROR;
  // TODO: Add specific data fields for CompanyCam errors
  data: Record<string, never>;
};

export const companyCamErrorDetails: Record<CompanyCamErrorType, ErrorDetails> = {
  [CompanyCamErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "CompanyCam external service error",
  },
};
